/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { shadowColor } from 'theme/color';
import { Card, Grid, Box } from '@mui/material';
import {
  displayFlex,
  fontsize24,
  poppins500,
  poppins400,
  fontsize16,
} from 'theme/common.style';
import Button from '@mui/material/Button';
import { alignCenter } from 'component/VendorStatusContainer/VendorStatusContainer.style';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import buyerRegistration from 'assets/icons/buyerregistration.svg';
import CardHeaderContainer from 'component/CardHeaderContainer/CardHeaderContainer';

function PropertyNearBy(props) {
  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
        marginTop: '14px',
      }}
    >
      <Grid>
        <Grid sx={{ ...poppins500, ...fontsize24 }}>What’s Nearby?</Grid>
        <Grid sx={{ ...poppins500, ...fontsize24, ...displayFlex }}>
          <CardHeaderContainer icon={buyerRegistration} />
          Education
        </Grid>

        <Grid container spacing={3}>
          <Grid
            item
            justifyContent="center"
            xs={4}
            sx={{
              ...poppins500,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            Brookside Doula
          </Grid>

          <Grid
            item
            xs={4}
            justifyContent="flex-end"
            sx={{
              ...poppins400,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            <Button
              size="small"
              variant="contained"
              disableElevation
              color="success"
            >
              Exceptional
            </Button>
          </Grid>
          <Grid
            item
            xs={4}
            justifyContent="flex-end"
            sx={{
              ...poppins400,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            <Rating name="simple-controlled" />3 Reviews
          </Grid>

          <Grid
            item
            xs={4}
            justifyContent="center"
            sx={{
              ...poppins500,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            Brookside Doula
          </Grid>
          <Grid
            item
            xs={4}
            justifyContent="flex-end"
            sx={{
              ...poppins400,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            <Button
              size="small"
              variant="contained"
              disableElevation
              color="success"
            >
              Exceptional
            </Button>
          </Grid>
          <Grid
            item
            xs={4}
            justifyContent="flex-end"
            sx={{
              ...poppins400,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            <Rating name="simple-controlled" />3 Reviews
          </Grid>
          <Grid
            item
            xs={4}
            justifyContent="center"
            sx={{
              ...poppins500,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            Brookside Doula
          </Grid>
          <Grid
            item
            xs={4}
            justifyContent="flex-end"
            sx={{
              ...poppins400,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            <Button
              size="small"
              variant="contained"
              disableElevation
              color="success"
            >
              Exceptional
            </Button>
          </Grid>
          <Grid
            item
            xs={4}
            justifyContent="flex-end"
            sx={{
              ...poppins400,
              ...fontsize16,
              ...displayFlex,
              ...alignCenter,
            }}
          >
            <Rating name="simple-controlled" />3 Reviews
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

PropertyNearBy.propTypes = {};

export default PropertyNearBy;
